import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CustomInput
} from 'reactstrap';

import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { postAPI_User_External_Images } from '../../../../../../constants/APIs';
import { NotificationManager } from "../../../../../../components/common/react-notifications";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import classnames from "classnames";

export function UploadIExternalImages({
    visible,
    toggleModal,
    formLabel,
    propertyId,
    parentLoadData
}) {
    const [isAgree, setAgree] = useState(false);
    const [errorModal, showErrorModal] = useState(false);
    const handleSubmit = () => {
        if (isAgree) {

            setApiState("processing")

            var img = new Image();
            img.onerror = function () {
                setApiState('default');
                NotificationManager.error(
                    "",
                    "Invalid Image Link",
                    3000,
                    null,
                    null,
                    "error"
                );
            }
            img.onload = function () {
                if (img.width) {
                    var height = img.height;
                    var width = img.width;

                    linkData.height = height;
                    linkData.width = width;

                    //  console.log(linkData)
                    // setApiState('success')
                    AxiosAPI({
                        method: 'post',
                        url: `${postAPI_User_External_Images}`,
                        data: linkData
                    }).then(
                        res => {
                            setApiState('success')
                            toggleModal();
                            parentLoadData();
                        },
                        error => {
                            setApiState('fail')
                            console.log('eee.data', error.data);
                        }
                    );
                }
                else {
                    setApiState('default');
                    NotificationManager.error(
                        "",
                        "Invalid Image Link",
                        3000,
                        null,
                        null,
                        "error"
                    );
                }
            }

            img.src = linkData.imageLink;
        }
        else {
            showErrorModal(true);
        }
    };

    const [linkData, setlinkData] = useState({
        groupId: getGroupID(),
        propertyId: propertyId,
        imageLink: '',
        width: 0,
        height: 0,
        tags: [],
        creator: 'dashboard',
        caption: ''
    });
    const [ApiState, setApiState] = useState('default');
    const handleChange = e => {
        setlinkData({
            ...linkData,
            [e.target.name]: e.target.value,
        });
    };
    const handleTagChange = (event) => {
        setlinkData({
            ...linkData,
            tags: event,
        });
    };


    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggleModal} size="lg">
                <ModalHeader toggle={toggleModal}>{formLabel}</ModalHeader>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <Row>
                                <Colxx sm={12} className="mb-6">
                                    <Label>Link</Label>
                                    <Input
                                        type="text"
                                        value={linkData.imageLink}
                                        onChange={handleChange}
                                        name="imageLink"
                                    />
                                </Colxx>
                            </Row>
                            <Row>
                                <Colxx sm={12} className="mb-6">
                                    <Label>Search Tags</Label>
                                    <TagsInput
                                        value={linkData.tags}
                                        onChange={event => handleTagChange(event)}
                                    />
                                </Colxx>
                            </Row>
                            <Row>
                                <Colxx sm={12} className="mb-6">
                                    <Label>Caption</Label>
                                    <Input
                                        type="text"
                                        value={linkData.caption}
                                        onChange={handleChange}
                                        name="caption"
                                    />
                                </Colxx>
                            </Row>
                        </Colxx>
                    </Row>
                    <div className='row my-1 ml-0  font-weight-bold'>
                        <CustomInput
                            type="checkbox"
                            id="agree"
                            value={isAgree}
                            checked={isAgree}
                            onChange={(e) => {
                                setAgree(!isAgree);
                            }}
                        >
                            <span className='mt-1' style={{ verticalAlign: 'middle' }}>I have copyright or permissions to use this image</span>

                        </CustomInput>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleSubmit}
                        className={`btn-multiple-state ${classnames(
                            {
                                "show-spinner": ApiState === "processing",
                                "show-success": ApiState === "success",
                                "show-fail": ApiState === "fail"
                            }
                        )}`}
                    >
                        <span className="spinner d-inline-block">
                            <span className="bounce1" />
                            <span className="bounce2" />
                            <span className="bounce3" />
                        </span>
                        <span className="icon success">
                            <i className="simple-icon-check" />
                        </span>
                        <span className="icon fail">
                            <i className="simple-icon-exclamation" />
                        </span>
                        <span className="label">Save</span>
                    </Button>
                    <Button color="secondary" onClick={toggleModal}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={errorModal} toggle={() => showErrorModal(!errorModal)}>
                <ModalHeader toggle={() => showErrorModal(!errorModal)}>{formLabel}</ModalHeader>
                <ModalBody>
                    <div className='m-2'>
                        <h5>Please check the copyright or permissions check box</h5>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => showErrorModal(!errorModal)}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </Fragment >
    );
}